import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import * as DictConstants from '../../../../constants/DictConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'
import { API_BASE_URL } from '../../../../common/utils/commonUrl'
import http from '../../../../common/utils/http';

export default {
  data () {
    return {
      activeName: 'first',
      state: false,
      priceShowStatus: false,
      centerDialogVisible: false,
      qrCode: '',
      dialogVisible: false,
      notCsedCouponList: [],
      centerHeight: document.documentElement.clientHeight - 90 + 'px',
    }
  },
  computed: {
    ...mapState('couponModule', ['couponInfo', 'generateImg', 'couponInfoExpired']),
    couponList () {
      let arr = this.couponInfo.map(item => {
        return {
          ...item,
          isShow: false,
          qrCode: `${API_BASE_URL}/api/qr/generate?content=${item.couponExampleCode}&X-Authorization=${localStorage.getItem("token")}`
        }
      })
      this.notCsedCouponList = arr
      return arr
    },
    generate () {
      return this.generateImg
    },
    muCouponNum () {
      return `未使用`
      // return `未使用 (${this.couponInfo.length})`
    }
  },
  methods: {
    ...mapActions('couponModule', ['getCouponByCouponUseStatus', 'updateCoupon', 'updateCouponFalse',
      'getGenerateByCouponCode', 'getUserReasonCouponListByMemberId']),
    generateUrl (content) {
      this.qrCode = `//${location.host}/api/qr/generate?content=${content}&X-Authorization=${localStorage.getItem('token')}`
    },
    handleClick (tab, event) {
      if (tab.name === 'first') {
        const data = {
          couponUseStatus: DictConstants.COUPON_USE_STATUS_UNWRITTEN
        }
        this.getCouponByCouponUseStatus(data)
      } else if (tab.name === 'second') {
        const data = {
          couponUseStatus: DictConstants.COUPON_USE_STATUS_WRITTEN_OFF
        }
        this.getCouponByCouponUseStatus(data)
      } else {
        const data = {
          couponUseStatus: DictConstants.COUPON_USE_STATUS_EXPIRED
        }
        this.getCouponByCouponUseStatus(data)

      }
    },
    dateFormat (time) {
      // if (time) {
      //   return dateUtils.dateFormatTime(time)
      // }
      // return ''
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    arrowDown (e) {
      this.updateCoupon(e)
    },
    arrowUp (e) {
      this.updateCouponFalse(e)
    },
    couponClick (item) {
      this.dialogVisible = true
      this.qrCode = item.qrCode
    },
    showInfo (index) {
      this.notCsedCouponList[index].isShow = true
    },
    hiedInfo (index) {
      this.notCsedCouponList[index].isShow = false
    },
    getAppConfigs () {
      const appConfigs = JSON.parse(localStorage.getItem('appConfig')) || []
      let list = appConfigs.filter(item => item.code === DictionaryConstants.COUPON_SHOW_AMOUNT)
      const appConfig = list.length > 0 ? list[0] : {}
      this.priceShowStatus = appConfig.value === 'Y'
    }
  },
  watch: {
    notCsedCouponList (val) {
      this.notCsedCouponList = val
    }
  },
  mounted () {
    // 查询卡券
    const data = {
      couponUseStatus: DictionaryConstants.COUPON_USE_STATUS_UNWRITTEN
    }
    this.getCouponByCouponUseStatus(data)
    // 判断卡劵显示金额权限
    this.getAppConfigs()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/views/my-coupon.js